import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { useCallback } from "react";
import { LayerListOrdered } from "./LayerListOrdered.js";
import { useAppSelector } from "../../hooks/redux.js";
import { getLayersConfigDisplay, getLayersListDisplay, getSelectedLayer } from "../../reducers/layersReducer.js";
import { LayerListGrouped } from "./LayerListGrouped.js";
import { LayerConfigCode } from "./LayerConfigCode.js";
import { LayerConfigStyle } from "./LayerConfigStyle.js";
import { LayerConfigData } from "./LayerConfigData.js";
import { getSelectedLayerSourceInfo } from "../../utils/selectors.js";
import { get } from "es-toolkit/compat";
import { useCaptureEvent } from "../../components/StyleEditorContext.js";
import { Event } from "../../constants/events.js";
export const LayersView = ({ onViewChange }) => {
    const captureEvent = useCaptureEvent();
    const selected = useAppSelector(getSelectedLayer);
    const listDisplay = useAppSelector(getLayersListDisplay);
    const configDisplay = useAppSelector(getLayersConfigDisplay);
    const sourceInfo = useAppSelector(getSelectedLayerSourceInfo);
    const onClose = useCallback(() => {
        captureEvent(Event.CloseLayersPanel);
        onViewChange("ai");
    }, [captureEvent, onViewChange]);
    let sourceLayerId = "";
    if (selected && "source-layer" in selected) {
        sourceLayerId = get(selected, "source-layer", "");
    }
    return (_jsxs(Flex, { h: "100%", w: selected ? "640px" : "320px", children: [listDisplay === "ordered" && (_jsx(LayerListOrdered, { selected: selected, onClose: onClose })), listDisplay === "grouped" && (_jsx(LayerListGrouped, { selected: selected, onClose: onClose })), selected && configDisplay === "code" && (_jsx(LayerConfigCode, { layer: selected })), selected && configDisplay === "style" && (_jsx(LayerConfigStyle, { layer: selected })), selected && "source-layer" in selected && configDisplay === "data" && (_jsx(LayerConfigData, { layer: selected, sourceLayerId: sourceLayerId, sourceInfo: sourceInfo })), _jsx("style", { children: `
          .layer-list-item:hover {
            background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-5));
          }
          .layer-group:hover {
            background: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-5));
          }
        ` })] }));
};
